import { gql } from '@apollo/client';

export const GET_UNLOADING_ORDER_DETAIL_WAYPOINT_COUNT_BY_TASK_ID_AND_WAYPOINT_ID = gql`
    query GetUnloadingOrderDetailWaypointCountByTaskIdAndWaypointId($taskId: Long!, $waypointId: Long!) {
        getUnloadingOrderDetailWaypointCountByTaskIdAndWaypointId(taskId: $taskId, waypointId: $waypointId) {
            waypointId
            parcelCount
            bagCount
        }
    }
`;

export interface TmsWaypointOrderDetailCountType {
    waypointId: number;
    parcelCount: number;
    bagCount: number;
}

export interface GetUnloadingOrderDetailWaypointCountByTaskIdAndWaypointIdResponse {
    getUnloadingOrderDetailWaypointCountByTaskIdAndWaypointId: TmsWaypointOrderDetailCountType | null;
}

export interface GetUnloadingOrderDetailWaypointCountByTaskIdAndWaypointIdVariables {
    taskId: number;
    waypointId: number;
}

